import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Phone } from 'lucide-react';
import { site } from '../data/site';
export function MobileCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-241" data-mp="14pqpy146sb7w">
      {visible && <motion.div initial={{
      y: 90
    }} animate={{
      y: 0
    }} exit={{
      y: 90
    }} transition={{
      duration: 0.35,
      ease: [0.22, 1, 0.36, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 flex gap-2 border-t border-white/10 bg-navy-900/95 p-3 backdrop-blur-xl sm:hidden" data-id="element-242" data-mp="14opgg12tjwsa">
          <a href="#contact" className="flex-1 rounded-full bg-brass py-3.5 text-center text-[11px] font-bold uppercase tracking-[0.16em] text-navy-900" data-id="element-243" data-mp="2u3ng3i52l7sb">
            Get a Free Estimate
          </a>
          <a href={site.phoneHref} aria-label={`Call ${site.phoneDisplay}`} className="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-white/25 text-white" data-id="element-244" data-mp="2s8wod9ekwrf5">
            <Phone className="h-5 w-5" aria-hidden="true" data-id="element-245" data-mp="2j99lej67bdjz" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}